/** Return best guess of viewer's preferred UI language as ISO 639-1 subtag. */
export function browserLang() {
  if (typeof navigator === "undefined") return "en";
  const raw = navigator.language || (navigator.languages && navigator.languages[0]) || "en";
  return (raw.toLowerCase().split("-")[0] || "en").slice(0, 5);
}

/** Display-friendly language name */
const NAMES = {
  en: "English", it: "Italian", es: "Spanish", fr: "French", de: "German",
  pt: "Portuguese", ja: "Japanese", zh: "Chinese", ar: "Arabic", ru: "Russian",
  hi: "Hindi", ko: "Korean", nl: "Dutch", sv: "Swedish", tr: "Turkish",
  pl: "Polish", uk: "Ukrainian", he: "Hebrew", el: "Greek", cs: "Czech",
  ro: "Romanian", da: "Danish", fi: "Finnish", no: "Norwegian",
};

export function langName(code) {
  if (!code) return "";
  const c = code.toLowerCase().split("-")[0];
  return NAMES[c] || c.toUpperCase();
}
